<template>
  <div>
    <p
      v-if="widthNow >= 550"
      class="Text-Hero"
      v-bind:style="{
        'font-size': fontSize,
        'margin-left': marginLeft,
        width: width,
        'margin-top': marginTop,
      }"
    >
      Dompet Kilat sebagai Platform untuk Berbagai Pendanaan Membangun Ekosistem
      Finansial
    </p>
    <p v-else class="Text-Hero-Mobile">
      Dompet Kilat sebagai Platform untuk Berbagai Pendanaan Membangun Ekosistem
      Finansial
    </p>
    <v-skeleton-loader
      type="image"
      max-height="545"
      v-if="!isImgLoaded && widthNow >= 550"
    ></v-skeleton-loader>
    <v-skeleton-loader
      type="image"
      max-height="545"
      v-if="!isImgLoaded && widthNow >= 550"
    ></v-skeleton-loader>
    <v-skeleton-loader
      type="image"
      max-height="506"
      v-if="!isImgLoaded && widthNow <= 550"
    ></v-skeleton-loader>
    <v-skeleton-loader
      type="image"
      max-height="506"
      v-if="!isImgLoaded && widthNow <= 550"
    ></v-skeleton-loader>
    <img
      v-if="widthNow >= 550"
      src="../assets/TentangKami/Hero.svg"
      @load="onImgLoad"
      class="Hero"
    />
    <img
      v-else
      src="../assets/TentangKami/Hero-mobile.png"
      srcset="
        ../assets/TentangKami/Hero-mobile@2x.png 2x,
        ../assets/TentangKami/Hero-mobile@3x.png 3x
      "
      @load="onImgLoad"
      class="Hero-Mobile"
    />
    <ApaItu v-if="widthNow >= 550" />
    <ApaItuMobile v-else />
    <Values v-if="widthNow >= 550" />
    <ValuesMobile v-else />
    <Leaders v-if="widthNow >= 550" />
    <LeadersMobile v-else />
    <Media v-if="widthNow >= 550" />
    <MediaMobile v-else />
    <!-- <Position v-if="widthNow >= 550" />
    <PositionMobile v-else /> -->
  </div>
</template>
<script>
import ApaItu from "../components/TentangKami/ApaItu.vue";
import ApaItuMobile from "../components/TentangKami/ApaItuMobile.vue";
import Leaders from "../components/TentangKami/Leaders.vue";
import LeadersMobile from "../components/TentangKami/LeadersMobile.vue";
import Media from "../components/TentangKami/Media.vue";
import MediaMobile from "../components/TentangKami/MediaMobile.vue";
// import Position from "../components/TentangKami/Position.vue";
// import PositionMobile from "../components/TentangKami/PositionMobile.vue";
import Values from "../components/TentangKami/Values.vue";
import ValuesMobile from "../components/TentangKami/ValuesMobile.vue";
export default {
  components: {
    ApaItu,
    ApaItuMobile,
    Values,
    ValuesMobile,
    Media,
    MediaMobile,
    // Position,
    // PositionMobile,
    Leaders,
    LeadersMobile,
  },
  data() {
    return {
      heroTextSize: `48px`,
      marginLeft: `${window.innerWidth / 8}px`,
      marginTop: `${window.innerWidth / 6}px`,
      width: `${window.innerWidth / 4}px`,
      widthNow: window.innerWidth,
      fontSize: `40px`,
      isImgLoaded: false,
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginLeft = `${window.innerWidth / 8}px`;
      this.marginTop = `${window.innerWidth / 7}px`;
      this.width = `${window.innerWidth / 3}px`;
      this.fontSize = `${window.innerWidth / 35}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    onImgLoad() {
      this.isImgLoaded = true;
    },
  },
};
</script>
<style scoped>
.Text-Hero {
  width: 763px;
  margin: 137px 810px 0 200px;
  font-family: Sora;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
  position: absolute;
}

.Text-Hero-Mobile {
  position: absolute;
  height: 120px;
  flex-grow: 0;
  margin: 40px 30px 0;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.48px;
  text-align: center;
  color: #252525;
}

.Hero {
  width: 100%;
  object-fit: contain;
}

.Hero-Loader {
  width: 100%;
  height: 545px;
}

.Hero-Mobile {
  width: 100%;
  object-fit: contain;
  margin-top: -75px;
}
</style>
